import QCheckbox from './src/QCheckbox.vue';

/* istanbul ignore next */
QCheckbox.install = function(Vue) {
  Vue.component(QCheckbox.name, QCheckbox);
};

export default QCheckbox;
